import { clientOnlyLazy } from '#/utils/clientOnlyLazy';

export const ClientOnlyLazySearchVolopsRefinements = clientOnlyLazy(() =>
  import('./SearchVolopsRefinements').then((m) => ({
    default: m.SearchVolopsRefinements,
  })),
);
